export const scrollToLocation = (toHeight) => {
  const scrollToTop = document.documentElement.scrollTop
  $("html,body").animate({
    scrollTop: scrollToTop + toHeight
  }, 500)
}